import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ACCRELEASETRANS,
  GET_ACCRELEASETRANS_ONE,
  DELETE_ACCRELEASETRANS,
  UPDATE_ACCRELEASETRANS,
  ADD_NEW_ACCRELEASETRANS,
} from "./actionType";

import {
  getAccReleaseTransSuccess,
  getAccReleaseTransFail,
  deleteAccReleaseTransSuccess,
  deleteAccReleaseTransFail,
  updateAccReleaseTransSuccess,
  updateAccReleaseTransFail,
  addAccReleaseTransSuccess,
  addAccReleaseTransFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAccReleaseTransApi,
  getAccReleaseTransApi,
  updateAccReleaseTransApi,
  deleteAccReleaseTransApi,
  addNewAccReleaseTransApi,
  getOneAccReleaseTransApi
} from "../../helpers/backend_helper";

function* getAccReleaseTrans({ payload: accReleaseTrans }) {
  try {
    const response = yield call(getAccReleaseTransApi, accReleaseTrans);
    yield put(getAccReleaseTransSuccess(GET_ACCRELEASETRANS, response.data));
  } catch (error) {
    yield put(getAccReleaseTransFail(GET_ACCRELEASETRANS, error));
  }
}

function* getAccReleaseTransOne({ payload: id }) {
  try {
    const response = yield call(getOneAccReleaseTransApi, id);
    yield put(getAccReleaseTransSuccess(GET_ACCRELEASETRANS_ONE, response.data));
  } catch (error) {
    yield put(getAccReleaseTransFail(GET_ACCRELEASETRANS_ONE, error));
  }
}

function* onUpdateAccReleaseTrans({ payload: accReleaseTrans }) {
  try {
    if (accReleaseTrans.setApprove) {
      const response = yield call(approveAccReleaseTransApi, accReleaseTrans);
      yield put(updateAccReleaseTransSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAccReleaseTransApi, accReleaseTrans);
      yield put(updateAccReleaseTransSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAccReleaseTransFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccReleaseTrans({ payload: accReleaseTrans }) {
  try {
    const response = yield call(deleteAccReleaseTransApi, accReleaseTrans);
    yield put(deleteAccReleaseTransSuccess({ accReleaseTrans, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccReleaseTransFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccReleaseTrans({ payload: accReleaseTrans }) {
  try {
    const response = yield call(addNewAccReleaseTransApi, accReleaseTrans);
    yield put(addAccReleaseTransSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccReleaseTransFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAccReleaseTrans() {
  yield takeEvery(GET_ACCRELEASETRANS, getAccReleaseTrans);
}

export function* watchGetAccReleaseTransOne() {
  yield takeEvery(GET_ACCRELEASETRANS_ONE, getAccReleaseTransOne);
}

export function* watchUpdateAccReleaseTrans() {
  yield takeEvery(UPDATE_ACCRELEASETRANS, onUpdateAccReleaseTrans);
}

export function* watchDeleteAccReleaseTrans() {
  yield takeEvery(DELETE_ACCRELEASETRANS, onDeleteAccReleaseTrans);
}

export function* watchAddNewAccReleaseTrans() {
  yield takeEvery(ADD_NEW_ACCRELEASETRANS, onAddNewAccReleaseTrans);
}

function* accReleaseTransSaga() {
  yield all([
    fork(watchGetAccReleaseTrans),
    fork(watchGetAccReleaseTransOne),
    fork(watchDeleteAccReleaseTrans),
    fork(watchUpdateAccReleaseTrans),
    fork(watchAddNewAccReleaseTrans)
  ]);
}

export default accReleaseTransSaga;
